export default "__VITE_ASSET__K0aVqiYZ__"